import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { InputField } from '../../../components/ui/input-field';
import { supabase } from '../../../integrations/supabase/client';

const PasswordRecovery: React.FC = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setEmail(e.target.value);
        setError('');
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!email) {
            setError('Por favor ingresa tu correo electrónico');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: `${window.location.origin}/reset-password`,
            });

            if (error) throw error;

            setSuccess(true);
        } catch (error: any) {
            console.error('Error en recuperación:', error);
            setError(error.message || 'Error al enviar el correo de recuperación');
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = () => {
        window.location.href = '/login';
    };

    if (success) {
        return (
            <main className="w-full h-screen flex relative bg-white max-md:flex-col max-md:h-auto">
                <div className="w-6/12 h-full flex flex-col items-center justify-center relative bg-neutral-100 max-md:w-full max-md:min-h-screen max-md:px-5 max-md:py-10 max-sm:p-5">
                    <img
                        src="https://api.builder.io/api/v1/image/assets/TEMP/e4fe78c69a4f9b2dff1a11d2f45f0885adf16022?width=690"
                        alt="Maxi Chatbot Whatsapp AI"
                        className="w-[345px] h-[114px] mb-[60px] max-md:w-[280px] max-md:h-auto max-md:mb-10 max-sm:w-[250px] max-sm:mb-[30px]"
                    />
                    <div className="w-[80%] flex flex-col max-md:w-full text-center">
                        <h1 className="text-[#2B3A51] text-center text-lg font-bold mb-[30px] max-sm:text-base max-sm:mb-5">
                            ¡Correo Enviado!
                        </h1>
                        <div className="bg-green-100 border border-green-400 text-green-700 px-6 py-4 rounded-lg mb-6">
                            <h2 className="text-lg font-semibold mb-2">📧 Revisa tu correo electrónico</h2>
                            <p className="mb-3">
                                Hemos enviado un enlace de recuperación a:
                            </p>
                            <p className="font-semibold text-[#2B3A51] mb-3">{email}</p>
                            <p className="text-sm">
                                Haz clic en el enlace del correo para restablecer tu contraseña.
                            </p>
                        </div>
                        <div className="text-sm text-gray-600">
                            <p className="mb-2">💡 <strong>Consejos:</strong></p>
                            <ul className="text-left list-disc list-inside space-y-1">
                                <li>Revisa tu carpeta de spam si no ves el correo</li>
                                <li>El enlace es válido por 1 hora</li>
                            </ul>
                        </div>
                        <button
                            type="button"
                            onClick={handleLogin}
                            className="text-[#2B3A51] text-center text-sm font-normal max-sm:text-[13px] bg-transparent border-none cursor-pointer hover:underline mt-6"
                        >
                            Volver al inicio de sesión
                        </button>
                    </div>
                </div>
                <section
                    className="w-6/12 h-full relative overflow-hidden max-md:w-full max-md:h-[400px] max-sm:h-[300px] max-md:hidden"
                    aria-label="Background image section"
                >
                    <img
                        src="https://api.builder.io/api/v1/image/assets/TEMP/906afa4b45dd2fb35efd3b52d64bc69d76718f6a?width=1742"
                        alt="Investment types in Colombia background"
                        className="w-full h-full object-cover"
                    />
                </section>
            </main>
        );
    }

    return (
        <main className="w-full h-screen flex relative bg-white max-md:flex-col max-md:h-auto">
            <div className="w-6/12 h-full flex flex-col items-center justify-center relative bg-neutral-100 max-md:w-full max-md:min-h-screen max-md:px-5 max-md:py-10 max-sm:p-5">
                <img
                    src="https://api.builder.io/api/v1/image/assets/TEMP/e4fe78c69a4f9b2dff1a11d2f45f0885adf16022?width=690"
                    alt="Maxi Chatbot Whatsapp AI"
                    className="w-[345px] h-[114px] mb-[60px] max-md:w-[280px] max-md:h-auto max-md:mb-10 max-sm:w-[250px] max-sm:mb-[30px]"
                />
                <div className="w-[325px] flex flex-col max-md:w-full max-md:max-w-[400px] max-sm:w-full max-sm:max-w-xs">
                    <h1 className="text-[#2B3A51] text-center text-lg font-bold mb-[30px] max-sm:text-base max-sm:mb-5">
                        Recuperar Contraseña
                    </h1>
                    {error && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="w-full">
                        <InputField
                            label="Correo Electrónico"
                            placeholder="Example@gmail.com"
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleInputChange}
                            required
                        />
                        <Button 
                            type="submit" 
                            variant="default" 
                            className="w-full mb-5 rounded-[45px] mt-4"
                            disabled={loading}
                        >
                            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
                        </Button>
                    </form>
                    <button
                        type="button"
                        onClick={handleLogin}
                        className="text-[#2B3A51] text-center text-sm font-normal max-sm:text-[13px] bg-transparent border-none cursor-pointer hover:underline"
                    >
                        Iniciar Sesión
                    </button>
                </div>
            </div>
            <section
                className="w-6/12 h-full relative overflow-hidden max-md:w-full max-md:h-[400px] max-sm:h-[300px] max-md:hidden"
                aria-label="Background image section"
            >
                <img
                    src="https://api.builder.io/api/v1/image/assets/TEMP/906afa4b45dd2fb35efd3b52d64bc69d76718f6a?width=1742"
                    alt="Investment types in Colombia background"
                    className="w-full h-full object-cover"
                />
            </section>
        </main>
    );
};

export default PasswordRecovery;
